<template>
    <transition appear :enter-active-class="'animated' + (position === 'left' ? ' fadeInLeft' : ' fadeInRight')" :leave-active-class="'animated' + (position === 'left' ? ' fadeOutLeft' : ' fadeOutRight')">
        <div
            v-if="visible"
            :class="position === 'left' ? 'btn_left' : position === 'left-review' ? 'btn_left_review' : 'qbtn'"
            :style="
                (bgColor ? 'background-color:' + bgColor + ';' : '') +
                (textColor ? 'color:' + textColor + ';' : '') +
                (bottom ? 'bottom:' + bottom + ';' : '') +
                (text === null ? 'border-radius: 50%; padding: 1vmin 1.33vmin;' : 'border-radius: 40px; padding: 1vmin 1.33vmin;')
            "
            :onclick="onClick"
            style="cursor: pointer"
        >
            <q-icon v-if="!textOnly && (iconPosition === 'left' || (iconPosition === null && position === 'left'))" :name="icon ? icon : 'arrow_back_ios'" />
            <!-- <cus-button v-if="!textOnly && (iconPosition === 'left' || (iconPosition === null && position === 'left'))" :type="310" :label="text" /> -->
            <!-- <div v-if="!textOnly && (iconPosition === 'left' || (iconPosition === null && position === 'left'))" :class="!textOnly && (iconPosition === 'left' || (iconPosition === null && position === 'left')) ? 'button-back' : null" /> -->
            <div>{{ text }}</div>
            <q-icon v-if="!textOnly && (iconPosition === 'right' || (iconPosition === null && position === 'right'))" :name="icon ? icon : 'arrow_forward_ios'" />
            <!-- <div v-if="!textOnly && (iconPosition === 'right' || (iconPosition === null && position === 'right'))" :class="!textOnly && (iconPosition === 'right' || (iconPosition === null && position === 'right')) ? 'button__next__icon' : null" /> -->
        </div>
    </transition>
</template>

<script setup>
import { soundEffect } from '@/helpers/soundEffect';
import { onMounted, onUnmounted, defineEmits, watch, ref, defineProps } from 'vue';
import CusButton from '../widget/CusButton.vue';

const emit = defineEmits(['onClick']);
const position = ref('right');
const visible = ref(false);
const bgColor = ref(null);
const textColor = ref(null);
const bottom = ref(null);
const iconPosition = ref(null);
const text = ref(null);
const textOnly = ref(false);
const icon = ref(false);
const props = defineProps({
    visible: {
        default: false,
    },
    position: {
        default: 'right',
    },
    text: {
        default: null,
    },
    bgColor: {
        default: null,
    },
    textColor: {
        default: null,
    },
    bottom: {
        default: null,
    },
    icon: {
        default: null,
    },
    textOnly: {
        default: false,
    },
    iconPosition: {
        default: null,
    },
});

let isValidBtn = true;
const onClick = () => {
    if (isValidBtn) {
        isValidBtn = false;
        emit('onClick', true);
        soundEffect('next');
        setTimeout(() => {
            isValidBtn = true;
        }, 500);
    }
};

const init = () => {
    position.value = props.position;
    visible.value = props.visible;
    bgColor.value = props.bgColor;
    textColor.value = props.textColor;
    bottom.value = props.bottom;
    iconPosition.value = props.iconPosition;
    text.value = props.text;
    textOnly.value = props.textOnly;
    icon.value = props.icon;
};

watch(
    () => props.position,
    (newValue) => {
        init();
    },
);
watch(
    () => props.visible,
    (newValue) => {
        init();
    },
);
watch(
    () => props.bgColor,
    (newValue) => {
        init();
    },
);
watch(
    () => props.textColor,
    (newValue) => {
        init();
    },
);
watch(
    () => props.iconPosition,
    (newValue) => {
        init();
    },
);
watch(
    () => props.text,
    (newValue) => {
        init();
    },
);
watch(
    () => props.textOnly,
    (newValue) => {
        init();
    },
);
watch(
    () => props.icon,
    (newValue) => {
        init();
    },
);
watch(
    () => props.bottom,
    (newValue) => {
        init();
    },
);
watch(
    () => props.bottom,
    (newValue) => {
        init();
    },
);
watch(
    () => props.textColor,
    (newValue) => {
        init();
    },
);

onMounted(() => {
    position.value = props.position;
    visible.value = props.visible;
    bgColor.value = props.bgColor;
    textColor.value = props.textColor;
    bottom.value = props.bottom;
    iconPosition.value = props.iconPosition;
    text.value = props.text;
    textOnly.value = props.textOnly;
    icon.value = props.icon;

    // console.log('floating button:', props);
});

onUnmounted(() => {
    // root.dispose();
});
</script>

<style scoped lang="scss">
.qbtn {
    display: inline-flex;
    align-items: center;
    position: fixed;
    //bottom: 20vh;
    bottom: 15.83vmin;
    right: 10px;
    height: 45px;
    margin: 0.83vmin;
    // padding: 2.75vmin 3.33vmin;
    padding: 12px 32px;
    border-radius: 40px;
    background-color: $color_primary;
    // font-size: 2vmin;
    font-size: 14px;
    color: white;
    cursor: pointer;
    z-index: 5998;
}

.btn_left {
    display: inline-flex;
    align-items: center;
    position: fixed;
    //bottom: 20vh;
    bottom: 17vmin;
    left: 10px;
    height: 45px;
    margin: 0.83vmin;
    // padding: 2.75vmin 3.33vmin;
    padding: 12px 32px;
    border-radius: 40px;
    //background-color: #d5d5d5db;
    background-color: $color_gray_400;
    // font-size: 2vmin;
    font-size: 14px;
    color: gray;
    cursor: pointer;
    z-index: 9999;
}

.btn_left_review {
    display: inline-flex;
    align-items: center;
    position: fixed;
    bottom: 17vmin;
    height: 45px;
    margin: 0.83vmin;
    padding: 12px 32px;
    border-radius: 40px;
    background-color: $color_gray_400;
    font-size: 14px;
    color: gray;
    cursor: pointer;
    z-index: 9999;
}

.answer {
    position: relative;
    // padding: 0 4.17vmin;

    &__scroll {
        padding: 0 5.17vmin 3.33vmin 4.08vmin;
        // padding-right: 5.17vmin;
        // padding-bottom: 3.33vmin;
    }

    &--next {
        width: 4.9vw;
        height: 4.9vw;
        margin-right: 3.33vmin;

        &--review {
            width: 4.9vw;
            height: 4.9vw;
            margin-right: 3.33vmin;
            color: gray;
            background-color: $color_gray_400;
        }
    }

    &--prev {
        width: 3.5vw;
        height: 3.5vw;
        margin-left: 2.5vmin;

        &--review {
            width: 4.9vw;
            height: 4.9vw;
            margin-right: 3.33vmin;
        }
    }

    &--txt {
        // height: 4.9vw;
        height: inherit;
        max-height: 4.9vw;
        padding: 2.75vmin 3.42vmin !important;
        margin-right: 3.33vmin;
        font-size: 1.2vw;
        font-weight: 700;
        line-height: 1.6vw;
        @include border-radius(2.5vw !important);
    }

    .q-icon {
        margin: 0 auto;
        font-size: 1.3vw;
    }
}

::v-deep {
    .q-icon {
        margin: 0 auto;
        font-size: 1.3vw;
    }
}
</style>
